<template>
  <div class="new-workload-to-existing-opp">
    <div class="workload-header">
      <v-layout
        v-if="oppregStep === 'workload' || oppregStep === 'viewOppForm' "
        row
        wrap
        align-center
        class="mx-3">
        <v-btn
          @click="goBackToList">Go Back to List</v-btn>
        <v-btn color="success" v-if="oppregStep ==='viewOppForm'" @click ="setShowWorkloadForm">View Workload</v-btn>
        <v-btn color="success" v-if="oppregStep ==='workload'" @click ="setShowOppForm">View Opportunity</v-btn>
      </v-layout>
    </div>
    <div class="workload-data">
      <div
        v-if="oppregStep === 'listing'"
        class="workload-list mt-4 mx-3">
        <material-card class="shutdown-box">
          <div class="headline black--text">
            <p class="shutdown-text">If this is  a Galaxy malfunction issues, please send an urgent email to  <a href="mailto:GuardiansoftheGalaxy@dxc.com">GuardiansoftheGalaxy@dxc.com</a>.</p>
            <p class="shutdown-text">If this is a registration issue related to funding, please send an urgent email to <a href="mailto:AWS-Oppreg@cloud.dxc.com">AWS-Oppreg@cloud.dxc.com</a></p>
          </div>
        </material-card>
        <material-card
          color="orange"
          title="Opportunity Registration Requests">

          <v-layout
            row
            wrap>
            <v-flex>
              <v-layout row justify-xl-start class="search-box">
                <v-flex md3>
                  <v-menu
                    v-model="fromDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="from_date"
                        label="Start Date"
                        prepend-icon="event"
                        clearable
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      :max="new Date().toISOString().substr(0, 10)"
                      v-model="from_date"
                      @input="fromDateModal = false"/>
                  </v-menu>
                </v-flex>

                <v-flex md3>
                  <v-menu
                    v-model="endDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="to_date"
                        label="End Date"
                        prepend-icon="event"
                        clearable
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      :max="new Date().toISOString().substr(0, 10)"
                      v-model="to_date"
                      @input="endDateModal = false" />
                  </v-menu>
                </v-flex>

                <v-spacer />
              </v-layout>
              <v-layout
                row
                wrap>
                <v-flex
                  xs12
                  sm4
                  md4
                  xl4
                  offset-lg1
                  pt-2
                  ml-3>
                  <label>DXC SFDC Opportunity ID:</label>
                  <v-text-field
                    v-model.trim="opportunityId"
                    solo
                    placeholder="DXC SFDC OPPORTUNITY ID"/>
                  <label>Customer Name:</label>
                  <v-text-field
                    v-model.trim="Customer_Name"
                    solo
                    placeholder="CUSTOMER NAME"/>
                  <label>AWS ACE ID:</label>
                  <v-text-field
                    v-model.trim="AWS_ACE_ID"
                    solo
                    placeholder="AWS ACE ID"/>
                  <v-btn
                    :loading="newOppRegistration.searching"
                    color="success"
                    @click="filterOppRegRequestData">Search</v-btn>
                </v-flex>

                <v-flex
                  xs12
                  sm2
                  md2
                  xl2
                  offset-lg1
                  ml-3>
                  <h4>Choose Region</h4>
                  <!-- <v-radio-group v-model="ESRegion">
                    <template v-for="item in filteredRegions">
                      <v-radio
                        :label="item"
                        :value="item"
                        color="orange"/>
                    </template> -->
                  <div
                    v-for="region in filteredRegions"
                    :key="region">
                    <v-checkbox
                      v-model="selectedESRegion"
                      :disabled="includesRegion(region)"
                      :label="region"
                      :value="region"
                      hide-details
                      multiple
                      color="orange"
                      @change="onSelectESRegion"
                    />
                  </div>
                  </v-radio-group>

                </v-flex>

                <v-flex
                  xs13
                  sm3
                  md3
                  xl3
                  mx-3>
                  <h4>Choose Status</h4>
                  <v-select
                      v-model="Workload_Status"
                      :items="filteredWorkBookStatus"
                      label="Filter by Status"
                      solo
                      attach/>

                  <label>Requestor Email:</label>
                  <v-text-field
                    v-model.trim="RequestorEmail"
                    solo
                    placeholder="Requestor Email"/>
                </v-flex>

                <v-flex
                  xs12
                  sm2
                  md2
                  xl2>
                  <h4>Choose Form</h4>
                  <v-radio-group v-model="ViewType">
                    <template v-for="item in filteredViewTypeList">
                      <v-radio
                        :label="item"
                        :value="item"
                        color="orange"/>
                    </template>
                  </v-radio-group>
                </v-flex>

              </v-layout>
            </v-flex>
          </v-layout>
          <!-- for submit multiple -->
          <v-layout
            v-show="selected.length > 0"
            align-end
            justify-end
            row
            fill-height
            class="mass-update-actions"
            transition="fade-transition">
            <v-flex
              md4
              align-self-center>
              <p class="subtitle-1 mb-0"><span class="font-weight-black">({{ selected.length }})</span> accounts selected</p>
            </v-flex>
            <p
              v-if="checkAbilityToSubmit"
              class="subtitle-1 mb-0"><span class="subtitle-1 mb-0">ERROR: {{ showError }}</span> </p>
            <v-flex
              md8
              style="text-align: right">
              <v-btn
                :disabled="checkAbilityToSubmit"
                small
                class="mr-2"
                color="orange"
                @click="viewAllReqSubmit" >Submit</v-btn>
            </v-flex>
          </v-layout>
          <!-- end submit multiple -->
          <v-data-table
            :headers="filteredWorkloadHeaders"
            :items="listWorkload"
            :pagination.sync="pagination"
            :loading="newOppRegistration.searching"
            :class="{ 'no-select': hasRegionFilter() }"
            v-model="selected"
            select-all="showError"
            item-key="Project_Id"
            disable-initial-sort
            hide-actions
            @contextmenu.prevent
          >

            <template v-slot:no-data>
              <v-alert
                v-if="!newOppRegistration.withError"
                :value="true"
                color="#000"
                icon="info">
                Loading Opportunity Registration Requests data...
              </v-alert>
              <v-alert
                v-else-if="newOppRegistration.withError"
                :value="true"
                color="#000"
                icon="warning">
                No Opportunity Registration request found! Please check Filters and try again.
              </v-alert>
            </template>

            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text-md-left text--darken-3"
                v-text="header.text"
              />
            </template>
            <template v-slot:items="props">
              <tr :active="props.selected" >
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    color="orange"
                    hide-details
                  />
                </td>
                <td>
                  <v-icon
                    small
                    title="View"
                    class="mr-2"
                    color="primary"
                    flat
                    @click="onShowWorkload(props.item)">{{iconType}}</v-icon>
                </td>
                <td>{{ props.item.OppReg_Id }}</td>
                <td>{{ props.item.SFDC_Oppty_Name }}</td>
                <td>{{ props.item.Workload_Title }}</td>
                <td>{{ props.item.Workload_Status }}</td>
                <td>{{ props.item.Campaign_Name }}</td>
                <td>{{ props.item.Workload_type }}</td>
                <td>{{ props.item.Customer_Name }}</td>
                <td>{{ props.item.Global_Registered }}</td>
                <td>{{ props.item.AWS_ACE_ID }}</td>
                <td>{{ props.item.Customer_Region }}</td>
                <td>{{ props.item.Country }}</td>
                <td>{{ props.item.Requestor_Last_Name +','+ props.item.Requestor_First_Name }}</td>
                <td>{{ props.item.Q4 }}</td>
                <td>{{ props.item.AWS_Notes}}</td>
                <td>{{ props.item.SFDC_Sales_Stage }}</td>
                <td>{{ props.item.SignDate }}</td>
                <td>{{ props.item.Date_Created }}</td>
              </tr>
            </template>
          </v-data-table>
          <v-progress-linear
            v-slot:progress
            v-if="loadingWorkloadData"
            color="orange"
            indeterminate/>
          <div class="text-xs-center mt-3" >
            <v-btn :disabled="!nextPageKey" small @click="showNextData">LOAD MORE...</v-btn>
          </div>
        </material-card>
      </div>
      <formUserOppregForm v-if="oppregStep==='viewOppForm'" :type="newOppRegistration.type"/>
      <formUserOppregWorkload
        v-if="oppregStep === 'workload'"
        :sfdc-id="opportunityId"
        :type="newOppRegistration.type"
        :view="'user'" />
    </div>
  </div>
</template>
<script>

import { mapMutations, mapState, mapActions } from 'vuex'

export default {
  $_veeValidate: { validator: 'new' },
  data () {
    return {
      // sfdcId: '',
      fromDateModal: false,
      endDateModal: false,
      from_date: '',
      to_date: '',
      opportunityId: '',
      Customer_Name: '',
      AWS_ACE_ID: '',
      ESRegion: '',
      selectedESRegion: [],
      RequestorEmail: '',
      Workload_Status: '',
      ViewType: '',
      selected: [],
      showError: 'Unable to submit, please check Workload Statuses upon submission.',
      regions: ['Americas', 'UKI', 'Europe', 'APJ-MEA'],
      initiatives: ['Glacier Campaign', 'Global Register Initiative'],
      WorkBookStatus: [
        'All',
        'AWS Reg Accepted',
        'Disqualified - AWS forecast conflict',
        'Disqualified - Incomplete',
        'Disqualified - No AWS scope',
        'Incomplete/Under Review',
        'LEGACY - Approved - Tier 1 23% - PPA',
        'LEGACY - Approved - Tier 1 23% - PPA SaaS',
        'LEGACY - Approved - Tier 2 - Custom EDP',
        'LEGACY - Approved - Tier 3 12%',
        'LEGACY - Internal - Tier 1 23% - PPA',
        'Opp Owner Email Sent',
        'Opp Owner Rejected',
        'OppReg Closed',
        'Shareshift',
        'Submitted by User',
        'Submitted to AWS'
      ],
      viewTypeList: ['Simple', 'Expanded'],
      iconType: '',
      pagination: {
        descending: true,
        sortBy: 'Date_Created',
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        size: 10
      }
    }
  },
  mounted () {
    this.$store.commit('user/requestOppreg/setOppregStep', 'listing')
    console.log('dito',this.regionFiltered)
    if (!this.regionFiltered) {
      this.$store.dispatch('user/requestOppreg/getOppRegRequestData', { size: this.pagination.size })
    } else {
      console.log('else regionFiltered', this.regionFiltered)
      this.selectedESRegion = this.regionFiltered
      this.$store.dispatch('user/requestOppreg/getOppRegRequestData', { size: this.pagination.size, ESRegion: this.regionFiltered.toString() })
    }
    this.iconType = 'visibility'
  },
  created() {
    console.log("WORKLOAD LIST")
    console.log(this.workloadList)
  },
  computed: {
    ...mapState('user/requestOppreg', ['sfdcId', 'OppRegRequestHeaders', 'workloadList', 'newOppRegistration', 'oppregStep', 'nextPageKey', 'loadingWorkloadData', 'listWorkload']),
    // opportunityId: {
    //   get: function () {
    //     return this.sfdcId
    //   },
    //   set: function (id) {
    //     this.$store.commit('user/requestOppreg/setSfdcId', id)
    //   }
    // },
    filteredWorkloadHeaders () {
      return this.OppRegRequestHeaders
    },
    filteredRegions () {
      return this.regions
    },
    filteredWorkBookStatus () {
      return this.WorkBookStatus
    },
    filteredViewTypeList () {
      return this.viewTypeList
    },
    checkAbilityToSubmit () {
      let loadToSubmit = [
        'Incomplete/Under Review',
        'Approved - Tier 3 12%',
        'Submitted by User',
        'Approved - Tier 1 23% - PPA',
        'Submitted to AWS',
        'Disqualified - Incomplete',
        'Disqualified – AWS forecast conflict']
      let validateSubmit = false

      for (var i = 0; i < this.selected.length; i++) {
        let toSubmit = loadToSubmit.includes(this.selected[i].Workload_Status)
        console.log(this.selected[i].Project_Id)
        console.log(toSubmit)
        if (toSubmit) {
          validateSubmit = true
          break
        }
      }
      return validateSubmit
    },
    regionFiltered () {
      const subjects = []
      this.$ability.rules.forEach(rule => {
        if (rule.actions === 'report-filter-regions' && rule.subject != null) {
          subjects.push(rule.subject)
        }
      })
      return subjects.length ? subjects : null
    }
  },
  methods: {
    ...mapMutations({
      clearWorkloadForm: 'user/requestOppreg/clearWorkloadForm',
      showNewWorkload: 'user/requestOppreg/showNewWorkload',
      setWorkloadData: 'user/requestOppreg/setWorkloadData',
      showEditWorkload: 'user/requestOppreg/showEditWorkload',
      showWorkload: 'user/requestOppreg/showWorkload',
      hideWorkload: 'user/requestOppreg/hideWorkload',
      resetNewOppRegistration: 'user/requestOppreg/resetNewOppRegistration',
      setValidatedRegistration: 'user/requestOppreg/setRegistrationIdValidation',
      // setOpportunityFound: 'user/requestOppreg/setOpportunityFound',
      delWorkloadFields: 'user/requestOppreg/delWorkloadFields'
    }),
    onSearchOpportunity () {
      console.log('searching opportunity')
      this.$store.dispatch('user/requestOppreg/getWorkloadsByOppId', this.opportunityId)
    },
    onCreateNewWorkload () {
      this.clearWorkloadForm()
      this.showNewWorkload(this.opportunityId)
    },
    onEditWorkload (workload) {
      this.setValidatedRegistration({
        loading: false,
        success: false,
        error: false,
        successMessage: '',
        validated: true
      })
      this.$store.commit('user/requestOppreg/setSfdcId', workload.OppReg_Id)
      this.$store.commit('user/requestOppreg/setWorkloadStep', 1)
      this.setWorkloadData({ ...workload })
      this.showEditWorkload(workload.OppReg_Id)
      this.$store.commit('setChangeLogRecord', {
        id: workload.Project_Id,
        changeFrom: { ...this.$store.state['user/requestOppreg'].workloadForm.fields } },
      { root: true }
      )
    },
    onShowWorkload(workload) {
      this.setValidatedRegistration({
        loading: false,
        success: false,
        error: false,
        successMessage: '',
        validated: true
      })
      this.$store.commit('user/requestOppreg/setOppregStep', 'viewOppForm')
      this.$store.commit('user/requestOppreg/setSfdcId', workload.OppReg_Id)
      this.$store.commit('user/requestOppreg/setWorkloadStep', 1)
      this.setWorkloadData({ ...workload })
      this.showWorkload(workload.OppReg_Id)

    },
    setShowWorkloadForm() {
      this.$store.commit('user/requestOppreg/setOppregStep', 'workload')
    },
    setShowOppForm() {
      this.$store.commit('user/requestOppreg/setOppregStep', 'viewOppForm')
    },
    filterOppRegRequestData () {
      this.resetNewOppRegistration()
      let params = {}
      if (!this.regionFiltered) {
        if (this.selectedESRegion && this.selectedESRegion.length) {
          const excludeArray = ['All Region', 'All']
          params['ESRegion'] = this.selectedESRegion.filter(item => !excludeArray.includes(item)).toString()
        }
      } else {
        params['ESRegion'] = this.regionFiltered.toString()
      }
      if (this.Workload_Status) {
        params.Workload_Status = this.Workload_Status
      }
      if (this.opportunityId) {
        params.sfdcId = this.opportunityId
      }
      if (this.Customer_Name) {
        params.Customer_Name = this.Customer_Name
      }
      if (this.from_date) {
        params.from_date = this.from_date
      }
      if (this.to_date) {
        params.to_date = this.to_date
      }
      if (this.RequestorEmail) {
        params.Requestor_Email = this.RequestorEmail
      }
      if (this.AWS_ACE_ID) {
        params.AWS_ACE_ID = this.AWS_ACE_ID
      }
      console.log('PARAMS', params)
      this.$store.dispatch('user/requestOppreg/getOppRegRequestData', params);
    },
    goBackToList () {
      this.clearWorkloadForm()
      this.$store.commit('user/requestOppreg/setOppregStep', 'listing')
      // this.hideWorkload()
    },
    viewAllReqSubmit () {
      this.$store.dispatch('user/requestOppreg/submitMultipleWorkload', this.selected)
    },
    onShowLogs (workload) {
      this.$store.dispatch('showLogRecords', workload.Project_Id)
    },
    checkAbilityToEdit (status) {
      let disabledStatus = [
        'Incomplete/Under Review',
        'Approved - Tier 3 12%',
        'Submitted by User',
        'Approved - Tier 1 23% - PPA',
        'Submitted to AWS',
        'Disqualified - Incomplete',
        'Disqualified – AWS forecast conflict'
      ]
      return disabledStatus.includes(status)
    },
    // showError () {
    //   return true
    // }
    showNextData () {
      this.pagination.rowsPerPage = this.listWorkload.length + this.pagination.rowsPerPage
      let params = {
        nextPageKey: this.nextPageKey,
        size: this.pagination.size,
        orderBy: 'Date_Created',
        order: 'DESC'
      }
      if (this.selectedESRegion && this.selectedESRegion.length) {
        const excludeArray = ['All Region', 'All']
        params['ESRegion'] = this.selectedESRegion.filter(item => !excludeArray.includes(item)).toString()
      }
      if (this.Workload_Status) {
        params.Workload_Status = this.Workload_Status
      }
      if (this.opportunityId) {
        params.sfdcId = this.opportunityId
      }
      if (this.Customer_Name) {
        params.Customer_Name = this.Customer_Name
      }
      if (this.from_date) {
        params.from_date = this.from_date
      }
      if (this.to_date) {
        params.to_date = this.to_date
      }
      if (this.RequestorEmail) {
        params.Requestor_Email = this.RequestorEmail
      }
      if (this.AWS_ACE_ID) {
        params.AWS_ACE_ID = this.AWS_ACE_ID
      }
      this.$store.dispatch('user/requestOppreg/getOppRegRequestData', params)
    },
    onSelectESRegion (event) {
      if (event.includes('All Region')) {
        this.selectedESRegion = this.regions
      } else {
        this.selectedESRegion = event
      }
    },
    includesRegion (region) {
      const hasRegionFilter = this.$ability.rules.some(rule => rule.actions === 'report-filter-regions')
      if (hasRegionFilter) {
        if (!this.$ability.can('report-filter-regions', region)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    hasRegionFilter () {
      return this.$ability.rules.some(rule => rule.actions === 'report-filter-regions')
    }
  }
}

</script>

<style lang="scss" scoped>
.new-workload-to-existing-opp {
  .header-title {
    background: #000;
    color: #fff;
    padding: 0 10px;
  }
  .search-container {
    background: #000;
  }

  .search-opp-btn {
    padding: 15px 30px;
  }

  .mass-update-actions {
  background: rgba(65, 179, 223, 0.3);
}
}
.no-select {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
.shutdown-box {
  background-color: antiquewhite !important;
  margin-bottom: 35px !important;
}
.shutdown-text {
  font-size: 16px !important;
  font-weight: bold;
  color: #000 !important;
  margin-bottom: 0px !important;
  }
</style>
